<div class="add-master-card-features">
  <formly-form [form]="form" [fields]="config.columns" [options]="options" [model]="model"></formly-form>

  <button nbButton status="primary" size="small" type="button" (click)="addMasterCardFeatures()" class="btn btn-primary"
          [disabled]="model.masterCardFeaturesId == null || model.masterCardFeaturesId.length === 0" i18n="@@SaveChanges">
    Добавить
  </button>
</div>
